module.exports = __webpack_public_path__ + "4b2f6bbe21efebc5567cd5a46852c501.png";